(function($) {
    var mxLoader = function(options) {
        var self, init;
        var $element, $loader;
        var defaults = {
            speed: 200,
            selector: 'body',
            block: '<div class="mx-loader"></div>',
            class: ''
        };

        if ($.isPlainObject(options)) {
            defaults = $.extend(true, defaults, options);
        }

        self = {
            init: function() {
                if (!init) {
                    $element = $(defaults.selector);
                    $loader = $(defaults.block);

                    defaults = $.extend(true, defaults, options);
                    isString(defaults.class, true) && $loader.addClass(defaults.class);

                    init = true;
                }

                return init;
            },

            show: function(speed) {
                if (self.init()) {
                    speed = self.speed(speed);
                    $element.append($loader);
                    $loader.stop(true).fadeIn(speed);
                }
            },

            hide: function(speed) {
                if (self.init()) {
                    speed = self.speed(speed);
                    $loader.stop(true).fadeOut(speed, function() {
                        $loader.detach();
                    });
                }
            },

            speed: function(speed) {
                return $.isNumeric(speed) ? parseInt(speed) | 0 : defaults.speed;
            }
        };

        return self;
    };

    /**
     * Проверка, является ли переменная строкой
     * Проверка на не пустаую строку
     */

    var isString = function(variable, noEmpty) {
        var answer = !!(variable === '' || (variable && variable.split));
        if (noEmpty === true) {
            answer = answer && variable.length > 0;
        }

        return answer;
    };

    window.mxLoader = new mxLoader();
})(jQuery);



// WEBPACK FOOTER //
// ./plugins/jquery.loader/js/jquery.loader.js